/** Project run lifecycle values (`lifecycle_status` / `lifecycleStatus`). */
export const PROJECT_LIFECYCLE_VALUES = ['NEW', 'COMPLETED', 'CANCELLED'] as const;
